export default __webpack_public_path__ + "static/topNavItems-do-2-dark-c5f2a7ccfeab3f1345fa4730406bc5016215b8cf6af938b8643e1b08f99b6e38.png";